import React from 'react'
import { storiesOf } from '@storybook/react'

import GameCardBottomInfoBarDefault from 'components/GameCard/components/GameCardBottomInfoBarDefault'
import { MatchStatus } from 'protos'

storiesOf('GameCard/GameCardBottomInfoBar/GameCardBottomInfoBarDefault', module)
  .addDecorator((story) => (
    <>
      <div style={{ padding: 32, backgroundColor: '#DDD' }}>{story()}</div>
      <div style={{ padding: 32, backgroundColor: '#DDD', width: 320, borderTop: '1px solid white' }}>{story()}</div>
    </>
  ))
  .add('default', () => (
    <GameCardBottomInfoBarDefault status={MatchStatus.MS_UPCOMING} />
  ))
